/// <amd-module name="Artifacts/Npm/commands/Badge" />
import { getBadgeCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createBadgeCommand = getBadgeCommandCreator();
